/**
 * Confetti & celebration helpers — UI Wave A.
 * Wrapper around `canvas-confetti` so call sites don't import the lib directly.
 * Respects prefers-reduced-motion automatically.
 */
import confetti from "canvas-confetti";

const PRIMARY = ["#1E3A8A", "#3B82F6", "#F59E0B", "#EF4444", "#10B981"];
const GOLD = ["#FFD700", "#FFC107", "#FF9800", "#FFB300", "#FFFFFF"];

function reducedMotion() {
  return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Small burst — for streak tick-up, correct answer streak, etc. */
export function smallBurst() {
  if (reducedMotion()) return;
  confetti({
    particleCount: 40,
    spread: 55,
    origin: { y: 0.6 },
    colors: PRIMARY,
    scalar: 0.8,
    disableForReducedMotion: true,
  });
}

/** Streak milestone — bigger, dual-side cannons. */
export function streakBurst() {
  if (reducedMotion()) return;
  const duration = 1500;
  const end = Date.now() + duration;
  (function frame() {
    confetti({ particleCount: 4, angle: 60, spread: 55, origin: { x: 0 }, colors: PRIMARY });
    confetti({ particleCount: 4, angle: 120, spread: 55, origin: { x: 1 }, colors: PRIMARY });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}

/**
 * Big celebration — mock exam pass (>= 75%), badge unlock, milestone.
 * Realistic exploding-firework style.
 */
export function bigCelebrate() {
  if (reducedMotion()) return;
  const duration = 2500;
  const end = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };
  function randomInRange(min, max) { return Math.random() * (max - min) + min; }
  (function frame() {
    const timeLeft = end - Date.now();
    const particleCount = 50 * (timeLeft / duration);
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }, colors: GOLD });
    confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }, colors: PRIMARY });
    if (timeLeft > 0) requestAnimationFrame(frame);
  })();
}

/** School pride — emoji shapes for fun moments (cap, book, brain). */
export function studentPride() {
  if (reducedMotion()) return;
  const shapes = ["🎓", "📚", "🧠", "🏆", "⭐"].map((emoji) =>
    confetti.shapeFromText({ text: emoji, scalar: 2 })
  );
  confetti({
    particleCount: 30,
    spread: 100,
    origin: { y: 0.6 },
    shapes,
    scalar: 2,
  });
}
